import { StyleSheet } from 'aphrodite'

const styles = StyleSheet.create({
  app: {
    display: 'flex',
    flexDirection: 'column',
    height: '100vh'
  },
  header: {
    flexShrink: 0,
    flex: 'none'
  },
  footer: {
    flexShrink: 0,
    flex: 'none'
  },
  content: {
    flex: 1,
    display: 'flex',
    minHeight: 0
  }
})

export default styles



// WEBPACK FOOTER //
// ./src/components/App/styles.js